import React from "react";
import { useEffect } from 'react';
function ShippingPolicy() {

    useEffect(() => {
            window.scrollTo(0, 0);
          }, []);

  return (
    <section className="product_damage_return_policy_section pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="inner-box">
              <h6>1) Which are the locations that you deliver to?</h6>
              <p>
                We deliver to over 2,500 cities in Malaysia covering 13,000+ pin
                codes.
              </p>
            </div>

            <div className="inner-box">
              <h6>2) How soon do you dispatch an order?</h6>
              <p>
                We stock mostproducts that we sell which enable us to ship your
                order within 2 - 3 working days of placing the order.
              </p>
              <p>
                In some cases, it may take 7 – 10 working days depending on item
                availability. Some products which are unavailable that need
                production, may take longer to dispatch. We will intimate you in
                such cases.
              </p>
            </div>

            <div className="inner-box">
              <h6>3) When will my order get delivered?</h6>
              <p>
                We provide 7 – 10 working days delivery in over 500 cities in
                Malaysia.
              </p>
            </div>

            <div className="inner-box">
              <h6>4) How much do you charge for delivery?</h6>
              <div>
                <table className="table table-responsive">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Weight</th>
                      <th>Price (RM)</th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>0-999 g</td>
                      <td>9</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>1 - 2 kg</td>
                      <td>10</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>2 - 4 kg</td>
                      <td>13</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>4 - 6 kg</td>
                      <td>16</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>6 - 8 kg</td>
                      <td>18</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="inner-box">
              <h6>5) How can I track my order?</h6>
              <p>
                You will be notified through a SMS once your order is shipped
                containing the courier tracking details.
              </p>
            </div>

            <div className="inner-box">
              <h6>6) Which courier do you use to deliver?</h6>
              <p>
                We used professional courier & French express courier to ship
                most orders.
              </p>
            </div>

            <div className="inner-box">
              <h6>
                7) What should I do if the carton is damaged or tampered at the
                time of taking the delivery?
              </h6>
              <p>
                We request you not to accept delivery of parcels where the
                carton is damaged, tampered or the brown-tape sealis open.
                Please take a photo of the parcel before refusing and email it
                to us on aammiisanthai@gmail.com
              </p>
            </div>

            <div className="inner-box">
              <h6>8) How do I know if my order is confirmed?</h6>
              <p>
                You will receive an email and an SMS for all successful orders.
                In your Aammii My Account, successful Prepaid orders will be in
                "Processing", "Packed" or "Complete" status depending upon the
                exact status of the order. Unsuccessful orders will be either in
                "Pending" or "Cancelled" status. You can always contact our
                customersupportfor any queries relating to the status of your
                order.
              </p>
            </div>

            <div className="inner-box">
              <h6>9) My bank account is debited but order status on the AAMMII is showing as Pending?</h6>
              <p>
              This happens in case the connection between our website and the payment gateway is broken due to issues like the slow internet. In case your bank account is debited but order status on our website is showing as Pending, do not worry as we receive a confirmation for all successful payments from our payment gateway the next day. On receipt of such confirmation, your order status will be updated to "Processing" (i.e. Confirmed).
              </p>
            </div>

            <div className="inner-box">
              <h6>10) How do I place bulk orders?</h6>
              <p>
              You can send in your inquiries about bulk orders to aammiisanthai@gmail.com
              </p>
            </div>

            <div className="inner-box">
              <h6>11) I don’t want the package to carry an invoice.</h6>
              <p>
              Invoices are mandatory to be put along with the parcel due to Government regulations.
              </p>
            </div>

            
            <div className="inner-box">
              <h6>12) Do you ship outside Malaysia?</h6>
              <p>
              We currently ship in Malaysia only. If you want delivery outside Malaysia, you can order from ourEmail: aammiisanthai@gmail.com
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default ShippingPolicy;
